import React from 'react';
import { SectionLabel } from './SectionLabel';
import { Bloom } from './Bloom';
export function AdReporting() {
  return <section className="relative isolate overflow-hidden border-b border-[#1a1a1a]" data-id="element-137" data-mp="buombqxwruxg">
      <Bloom size="md" className="right-0 top-[-6rem]" data-id="element-138" data-mp="gmg69imk72em" />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-12 px-6 py-20 lg:grid-cols-[1fr_1fr] lg:py-24" data-id="element-139" data-mp="gp2c9dtsx9uq">
        <div data-id="element-140" data-mp="3k3ok7re61i42">
          <SectionLabel data-id="element-141" data-mp="3k481r6zwm4hk">Ad reporting</SectionLabel>
          <h2 className="mt-8 text-3xl font-bold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-142" data-mp="3k5j6pa535ia9">
            Monthly reporting built in. No black box.
          </h2>
        </div>
        <div className="space-y-5 text-lg leading-relaxed text-neutral-400 lg:pt-16" data-id="element-143" data-mp="3u01eorhjbzzv">
          <p data-id="element-144" data-mp="2w2vl8ia99ll">
            You see what the ads spent and what they booked. Not impressions, not a slide deck.
          </p>
          <p data-id="element-145" data-mp="19dho5rhmzc1u">
            If something isn&rsquo;t working, you see it in the same report we do, and we tell you
            what we&rsquo;re changing.
          </p>
        </div>
      </div>
    </section>;
}